(() => {
  if (window.__oneUpAovThresholdUpsellLoaded) return;
  window.__oneUpAovThresholdUpsellLoaded = true;

  document.addEventListener('click', async (event) => {
    const prevButton = event.target.closest('.js-aov-slider-prev');
const nextButton = event.target.closest('.js-aov-slider-next');

if (prevButton || nextButton) {
  event.preventDefault();

  const module = event.target.closest('#AovThresholdUpsell');
  const slider = module?.querySelector('.aov-threshold-upsell__products');

  if (!slider) return;

  const amount = slider.clientWidth;

  slider.scrollBy({
    left: prevButton ? -amount : amount,
    behavior: 'smooth'
  });

  return;
}
    const button = event.target.closest('.js-aov-quick-add');

    if (!button) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    const module = button.closest('#AovThresholdUpsell');
    const errorElement = module?.querySelector(
      '.aov-threshold-upsell__error'
    );

    button.disabled = true;
    button.classList.add('is-loading');

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    try {
      const formData = new FormData();

      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add this item.'
        );
      }

      const cartDrawer = document.querySelector('cart-drawer');

      if (
        cartDrawer &&
        typeof cartDrawer.renderContents === 'function' &&
        data.sections
      ) {
        cartDrawer.renderContents(data);
      } else {
        window.location.reload();
      }

    } catch (error) {
      console.error('AOV quick add error:', error);

      if (errorElement) {
        errorElement.textContent =
          error.message ||
          'Something went wrong. Please try again.';

        errorElement.hidden = false;
      }

      if (button.isConnected) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
})();